const data = () => import('../views/statistic/data')
const special = () => import('../views/statistic/data/special')
const article = () => import('../views/statistic/data/article')
const manuscript = () => import('../views/statistic/data/manuscript')
const reviewer = () => import('../views/statistic/data/reviewer')
const batchExport = () => import('../views/statistic/data/export')
const graphic = () => import('../views/statistic/graphic')
const country = () => import('../views/statistic/graphic/country')
const atype = () => import('../views/statistic/graphic/acticalType')
const sissues = () => import('../views/statistic/graphic/specialIssues')
const path = '/statistic'

export default [
  {
    path: path + '/data',
    component: data,
    name: '/statistic/data',
    children: [
      {
        path: path + '/data/special',
        component: special,
        name: '/statistic/data/special'
      },
      {
        path: path + '/data/article',
        component: article,
        name: '/statistic/data/article'
      },
      {
        path: path + '/data/manuscript',
        component: manuscript,
        name: '/statistic/data/manuscript'
      },
      {
        path: path + '/data/reviewer',
        component: reviewer,
        name: '/statistic/data/reviewer'
      },
      {
        path: path + '/data/export',
        component: batchExport,
        name: '/statistic/data/export'
      }
    ]
  },
  {
    path: path + '/graphic',
    component: graphic,
    name: '/statistic/graphic',
    children: [
      {
        path: path + '/graphic/country',
        component: country,
        name: '/statistic/graphic/country'
      },
      {
        path: path + '/graphic/atype',
        component: atype,
        name: '/statistic/graphic/atype'
      },
      {
        path: path + '/graphic/sissues',
        component: sissues,
        name: '/statistic//graphic/sissuese'
      }
    ]
  }
]
